import { render, staticRenderFns } from "./Trade-Center-Account-Total.vue?vue&type=template&id=3d373da6&scoped=true"
import script from "./Trade-Center-Account-Total.vue?vue&type=script&lang=js"
export * from "./Trade-Center-Account-Total.vue?vue&type=script&lang=js"
import style0 from "./Trade-Center-Account-Total.vue?vue&type=style&index=0&id=3d373da6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d373da6",
  null
  
)

export default component.exports